"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Button_1 = require("./Button");
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const footer_scss_1 = __importDefault(require("./styles/footer.scss"));
const Scroller_1 = require("./Scroller");
const store_1 = require("./store");
function FooterPane({ assets, onRequestClose, search }) {
    if (search) {
        assets = assets.filter(asset => asset.name.includes(search));
    }
    const [tab, setTab] = React.useState(0);
    const refs = [0, 1, 2].map(() => React.useRef(null));
    const handleScroll = React.useCallback((e) => {
        const margin = 20; // safety margin for smooth scroll [px]
        const viewTop = e.currentTarget.offsetTop + e.currentTarget.scrollTop + margin;
        for (const tab of [0, 1, 2]) {
            const element = refs[tab].current;
            if (!element)
                return;
            const groupBottom = element.offsetTop + element.offsetHeight;
            if (viewTop < groupBottom) {
                setTab(tab);
                return;
            }
        }
    }, []);
    const scrollTo = React.useCallback((tab) => {
        const element = refs[tab].current;
        if (!element)
            return;
        element.scrollIntoView({ behavior: 'smooth' });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames_1.default(footer_scss_1.default.category, flex_scss_1.default.horizontal) },
            React.createElement("div", { className: flex_scss_1.default.blank, onClick: onRequestClose }),
            React.createElement("div", { className: classnames_1.default(footer_scss_1.default.wrapper, flex_scss_1.default.horizontal) },
                [0, 1, 2].map(cat => (React.createElement("button", { key: cat, className: classnames_1.default(footer_scss_1.default.item, tab === cat && footer_scss_1.default.selected, flex_scss_1.default.vertical), onClick: () => scrollTo(cat) },
                    "Category ",
                    cat))),
                React.createElement("div", { className: flex_scss_1.default.blank, onClick: onRequestClose })),
            React.createElement("div", { className: flex_scss_1.default.blank, onClick: onRequestClose })),
        React.createElement("div", { className: footer_scss_1.default.pane },
            React.createElement(Button_1.IconButton, { name: "close", className: footer_scss_1.default.close, onClick: onRequestClose }),
            React.createElement(Scroller_1.Scroller, { ms: 50, className: classnames_1.default(footer_scss_1.default.asset), onScroll: handleScroll }, [0, 1, 2].map(cat => (React.createElement("div", { key: cat, className: footer_scss_1.default.group, ref: refs[cat] },
                React.createElement("h3", { className: footer_scss_1.default.label },
                    "Category ",
                    cat),
                assets
                    .filter(asset => asset.category === cat)
                    .map(asset => (React.createElement(AssetButton, { key: asset.id, asset: asset, onRequestClose: onRequestClose }))))))))));
}
exports.FooterPane = FooterPane;
function AssetButton({ asset, onRequestClose }) {
    const dispatch = react_redux_1.useDispatch();
    const click = React.useCallback(() => {
        dispatch(store_1.actions.setEditorMode(store_1.EditorMode.Store));
        onRequestClose();
    }, []);
    return (React.createElement("button", { className: classnames_1.default(footer_scss_1.default.button, flex_scss_1.default.vertical), onClick: click },
        React.createElement("div", { className: flex_scss_1.default.blank }),
        React.createElement("div", { className: footer_scss_1.default.icon, style: { backgroundColor: asset.color } }),
        React.createElement("div", { className: flex_scss_1.default.blank }),
        React.createElement("div", { className: footer_scss_1.default.name }, asset.name),
        React.createElement("div", { className: flex_scss_1.default.blank })));
}
exports.AssetButton = AssetButton;
